const data = {
  antDesign: [
    "WarningOutlined",
    "ExportOutlined",
    "ToolFilled",
    "ExperimentFilled",
    "StarFilled",
    "GithubFilled",
    "MailOutlined",
    "LinkedinFilled",
    "TwitterOutlined (Bird)",
    "CaretRightOutlined",
    "QuestionOutlined",
    "DownCircleOutlined",
    "UpCircleOutlined",
    "DownloadOutlined",
    "EnvironmentFilled",
    "SettingOutlined"
  ],
  flaticonPixelPerfect: ["mechanical-arm.svg", "menu.svg"],
  flaticonFreepik: ["sketch.svg", "project.svg"],
  fontAwesome: [
    {
      name: "graduation-cap-solid.svg",
      href: "https://fontawesome.com/icons/graduation-cap?style=solid"
    },
    {
      name: "microchip-solid.svg",
      href: "https://fontawesome.com/icons/microchip?style=solid"
    },
    {
      name: "usb.svg",
      href: "https://fontawesome.com/icons/usb?f=brands&s=solid"
    }
  ],
  simpleIcons: [
    "angular.svg",
    "arduino.svg",
    "cplusplus",
    "csharp.svg",
    "git.svg",
    "java.svg",
    "linux.svg",
    "microsoft.svg",
    "node-dot-js.svg",
    "python.svg",
    "react.svg",
    "ros.svg",
    "unity.svg",
    "javascript.svg",
    "keras.svg",
    "overleaf.svg",
    "mongodb.svg",
    "atlassian.svg",
    "autodesk.svg",
    "c.svg",
    "docker.svg",
    "raspberrypi.svg",
    "vuedotjs.svg",
    "redis.svg",
    "flask.svg",
    "antdesign.svg",
    "nvidia.svg",
    "intel.svg",
    "zigbee.svg",
    "altiumdesigner.svg",
    "typescript.svg",
    "opencv.svg",
    "xilinx.svg",
    "anthropic.svg",
    "openai.svg",
    "googlegemini.svg",
    "bluesky.svg"
  ],
  devicon: ["visualbasic.svg"],
  lucide: [
    "dna.svg",
    "circuit-board.svg",
    "users.svg",
    "code-xml.svg",
    "box.svg",
    "factory.svg",
    "brain.svg",
    "sparkles.svg"
  ],
  handDrawn: ["matlab.svg", "labview.svg"],
  logowik: ["twitter-x.svg"]
};

export default data;
